import "./Insurance.module.css";
import Header from "@/reusable_sections/Header";
import HowWeWorkTogether from "./sections/HowWeWorkTogether";
import TheRevenueLifecycle from "./sections/TheRevenueLifecycle";
import AdvisorApplication from "./sections/AdvisorApplication";
import Footer from "@/reusable_sections/Footer";
export default function InsurancePage() {
  return <div>
      <Header />
      <HowWeWorkTogether />
      <TheRevenueLifecycle />
      <AdvisorApplication />
      <Footer />
    </div>;
}